import React from 'react'
import PropTypes from 'prop-types'
import Episode from './Episode'

const ChannelEpisode = ({ episode }) => {
    return (
      <Episode
        title={episode.title}
        subtitle={episode.itunes.subtitle}
        summary={episode.itunes.summary}
        published={episode.published}
        image={episode.itunes.image}
        duration={episode.itunes.duration}
        authors={episode.itunes.authors}
        link={episode.links[0]}
        enclosures={episode.enclosures}
      />
    )
}

ChannelEpisode.propTypes = {
  episode: PropTypes.object.isRequired
}
export default ChannelEpisode
